import { ChecklistenRequestPasswordResetForm } from '@/components/auth/checklisten-request-password-reset-form'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/request-password-reset')({
  component: RequestPasswordResetPage,
})

function RequestPasswordResetPage() {
  return (
    <div className="flex min-h-svh flex-col items-center justify-center p-6 md:p-10">
      <div className="w-full max-w-sm md:max-w-3xl">
        <ChecklistenRequestPasswordResetForm />
      </div>
    </div>
  )
}
